import { removeClassName } from 'utilities/classNameHandlers';

// The review wrappers conditions.tsx composes over a cell's viewer, and how to undo them.

/** Marks a grid cell that shows a pending AI suggestion. */
export const AI_SUGGESTED_CLASS = 'cell-ai-suggested';

/** The viewer a cell had before any review wrapper was composed over it, which may be none. */
export const reviewBaseOf = <V>(viewer: V): V =>
  viewer instanceof Object && 'reviewBase' in viewer ? (viewer as V & { reviewBase: V }).reviewBase : viewer;

type ReviewCell = { valueViewer?: unknown; aiFieldMetadata?: unknown; className?: string | null };

/** Returns a cleared cell to its pre-review look: base viewer, no AI suggestion and no AI class. */
export const undoReviewComposition = (cell: ReviewCell) => {
  Object.assign(cell, {
    aiFieldMetadata: null,
    valueViewer: reviewBaseOf(cell.valueViewer),
    className: removeClassName(cell.className ?? '', AI_SUGGESTED_CLASS),
  });
};
